import { LockKeyhole, LogOut } from "lucide-react";

import { BrandMark } from "../components/BrandMark";
import { ACCESS_BLOCKED_HELP } from "../../shared/company-access";
import type { UserSession } from "../lib/trpc";

/**
 * La porta chiusa, detta con garbo.
 *
 * Non e un errore e non e una schermata di accesso: la persona ha inserito le credenziali
 * giuste. Quello che deve capire e che **i suoi dati sono tutti li** e che basta una telefonata.
 * Per questo la pagina dice anche cosa succede ai dati, che e la vera domanda di chi legge.
 */
export function AccessBlockedPage({ session, onLogout }: { session: UserSession; onLogout: () => void }) {
  const motivo = session.company.access.reason ?? "L'accesso non e disponibile.";
  return (
    <main className="gate-page">
      <div className="gate-page__inner">
        <BrandMark />
        <span className="invite-card__icon"><LockKeyhole /></span>
        <p className="eyebrow">{session.company.name}</p>
        <h1>{motivo}</h1>
        <p>{ACCESS_BLOCKED_HELP}</p>
        <p className="gate-page__contact">
          <a href="mailto:cristian@cristianbedin.it">cristian@cristianbedin.it</a>
        </p>
        <button className="button button--ghost" type="button" onClick={onLogout}><LogOut size={17} /> Esci</button>
      </div>
    </main>
  );
}
